<div fxFlex>
  <div mat-dialog-title class="dialog-title">{{ title }} ({{roleData?.length}})</div>
  <div *ngFor="let obj of roleData">
      <div class="full-col maxPadding">
        <div class="value-f ">
          {{obj?.projectName}}
        </div>
        <div class="xsDesc-f">
          User: {{obj?.userCount}}
        </div>
      </div>
  </div>
</div>